import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import { handleChange } from "../../Controller/CreatePurchaseOrderController";
import PartService from '../../../Parts/Controller/PartController';
import PurchaseOrderService from "../../Controller/PurchaseOrderController";
import { useNavigate } from 'react-router-dom';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import { handleSubmit } from "../../../Jobs/Controller/CreateJobPartController";
import BatchSerialModal from "./BatchSerialModal";
function PurchaseOrderDeliveryModal({ show, OnSuccess, onClose, parts, setParts, bnt_OrderNumber, purchaseID, UnitOfSale = 0, CustomerID, jobID }) {
    const navigate = useNavigate();
    const { theme } = useContext(ThemeContext);
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const [formData, setFormData] = useState({
        vc_DeliveryCompanyName: "Stock System",
        dt_DeliveryDate: getCurrentDate(),
        bnt_OrderNumber: bnt_OrderNumber || '',
        bnt_DeliveryNumber: "",
        purchaseID: purchaseID,
        Complete: "0"
    });
    const [errors, setErrors] = useState({});
    const [stockLocationList, setStockLocationList] = useState([]);
    const [selectedDepot, setSelectedDepot] = useState({});
    const [showDepotModal, setShowDepotModal] = useState(false);
    const [activePartId, setActivePartId] = useState(null); // Tracks the part ID for which modal is opened
    const [purchaseItemID, setPurchaseItemID] = useState(null);
    const [modalType, setModalType] = useState(null);
    const [selectedPart, setSelectedPart] = useState(null);
    const tableRef = useRef();

    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const truncateText = (text, maxLength = 30) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    const handleStart = (e) => {
        e.stopPropagation();
    };

    const fetchStockLocations = async (PartID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page if needed
            };
            const listOfLocations = await PartService.GetPartLocation(redirectCallback, PartID);
            setStockLocationList(listOfLocations);
            setActivePartId(PartID); // Set the current part ID for which locations are being loaded
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };

    const handleDepotSelect = (depot) => {
        // Update selected depot for the specific PurchaseItemID (row)
        setSelectedDepot((prevState) => ({
            ...prevState,
            [purchaseItemID]: {
                PK_StockLocation_ID: depot.PK_StockLocation_ID, // Set the selected depot ID
                vc_Name: depot.vc_Name // Set the selected depot name
            }
        }));

        // If the selected depot is valid, update FK_Location_ID_Stock
        const updatedParts = parts.map(part =>
            part.PK_PurchaseOrderItem_ID === purchaseItemID
                ? { ...part, FK_Location_ID_Stock: depot.PK_StockLocation_ID }
                : part
        );

        setParts(updatedParts);  // Update parts with the new stock location
        setShowDepotModal(false); // Close the modal after selection
    };

    const openDepotModal = (partId, purchaseItemID) => {
        setActivePartId(partId); // Part ID for loading depots
        setPurchaseItemID(purchaseItemID); // Set PurchaseItemID for the specific row
        fetchStockLocations(partId); // Load depots for the part
        setShowDepotModal(true); // Open the modal
    };
    const handlePartChange = (index, newValue, fieldName) => {
        const updatedParts = [...parts]; // Assuming you have an array of parts
        if (fieldName === "vc_UnitOfSale") {
            updatedParts[index].vc_UnitOfSale = newValue; // Update vc_UnitOfSale with the new value
        }
        if (fieldName === "vc_SerialFormat") {
            updatedParts[index].vc_SerialFormat = newValue; // Update vc_UnitOfSale with the new value
        }
        if (fieldName === "vc_BatchNumber") {
            updatedParts[index].vc_BatchNumber = newValue; // Update vc_UnitOfSale with the new value
        }

        setParts(updatedParts); // Update state
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        try {

            if (formData.Complete === "1") {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You have choosen to close this Purchase Order without any delivery amount, is this correct!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes!'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            const postData = await PurchaseOrderService.CompletePOrder(purchaseID);
                            OnSuccess();
                        } catch (error) {
                            console.error('Error deleting job:', error);
                            Swal.fire(
                                'Error!',
                                'There was a problem deleting the record.',
                                'error'
                            );
                        }
                    }
                });
            }
            else {
                const validationErrors = {};
                if (!formData.bnt_DeliveryNumber.trim()) {
                    validationErrors.bnt_DeliveryNumber = 'Delivery Number cannot be empty';
                }
                const partsWithoutDepot = parts.filter(part =>
                    !selectedDepot[part.PK_PurchaseOrderItem_ID] || !selectedDepot[part.PK_PurchaseOrderItem_ID].PK_StockLocation_ID
                );


                //  if (partsWithoutDepot.length > 0) {
                //      validationErrors.depot = 'Please select a depot for all parts';
                //  }
                if (Object.keys(validationErrors).length > 0) {
                    setErrors(validationErrors);
                    return;
                }

                let status = 2; // Assume status is 1 by default
                for (const part of parts) {

                    const total = parseFloat(part.vc_UnitOfSale) + parseFloat(part.dec_Delivered);
                    if (Math.round(parseFloat(part.dec_OnOrder)) < Math.round(parseFloat(total))) {
                        Swal.fire(
                            '',
                            'The Delivered can not be greate than Orderd.',
                            'warning'
                        );
                        return;
                    }

                    if (parseFloat(part.dec_OnOrder).toFixed(2) !== (parseFloat(total).toFixed(2))) {
                        status = 1; // Set status to 2 if any do not match

                    }
                    debugger;
                    if (parseInt(part.snt_SerialTracking) > 0) {
                        if (!part.serialNumbers || part.serialNumbers.length === 0) {
                            Swal.fire(
                                'Error',
                                'Please Create the Serial Number for the Serial Tracked part.',
                                'error'
                            );
                            return;
                        }
                    }
                    if(parseInt(part.bit_BatchManagement)>0)
                    {
                        if(!part.vc_BatchNumber)
                        {
                            Swal.fire(
                                'Error',
                                'Please Create the Batch number for the batch managed parts.',
                                'error'
                            );
                            return;
                        }
                    }
                }
                formData.snt_DeliveryStatus = status;
                formData.CustomerID = CustomerID;
                formData.jobID = jobID;
                const formDataWithParts = {
                    formData: formData,
                    selectedParts: parts.map(part => ({
                        ...part,
                        PK_StockLocation_ID: selectedDepot[part.PK_PurchaseOrderItem_ID]?.PK_StockLocation_ID || part.FK_Location_ID_Stock || null
                    })),
                };
                if (jobID > 0) {
                    formData.FK_Issue_ID = jobID;
                    formData.ID = 0;
                    formData.FK_Stock_ID = 0;
                    const formDataWithNewParts = {
                        formData: formData,
                        selectedParts: parts
                    };

                    const Message = await handleSubmit(event, formDataWithNewParts, setFormData, setErrors);
                    const postData = await PurchaseOrderService.DeliverPurchaseOrder(event, formDataWithParts);
                    OnSuccess();
                }
                else {
                    const postData = await PurchaseOrderService.DeliverPurchaseOrder(event, formDataWithParts);
                    OnSuccess();
                }
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };
    const openModal = (type, part) => {
        setModalType(type);
        setSelectedPart(part);
    };

    const handleSave = (value, expiryDate, prefix, serialNumbers) => {
        setParts(prevParts => prevParts.map(p => p.PK_PurchaseOrderItem_ID === selectedPart.PK_PurchaseOrderItem_ID ? {
            ...p,
            vc_BatchNumber: modalType === 'batch' ? value : p.vc_BatchNumber,
            dt_ExpiryDate: expiryDate,
            vc_Prefix: modalType === 'serial' ? prefix : p.vc_Prefix,
            serialNumbers: modalType === 'serial' ? serialNumbers : p.serialNumbers
        } : p));
    };



    const handleRadioChange = async (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1" aria-labelledby="partModalLabel" aria-hidden={!show}>
            <div className="modal-dialog modal-md">
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                    <form onSubmit={handleFormSubmit}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="partModalLabel">Select Part</h5>
                                <button type="button" className="btn-close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px", "marginTop": "10px" }}>
                                    <label htmlFor="bnt_OrderNumber" className="col-sm-2 col-form-label">Purchase Order:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="bnt_OrderNumber" value={formData.bnt_OrderNumber} onChange={handleFieldChange} />
                                        {errors.bnt_OrderNumber && <div style={{ color: 'red' }}>{errors.bnt_OrderNumber}</div>}
                                    </div>
                                    <label htmlFor="vc_DeliveryCompanyName" className="col-sm-2 col-form-label">Delivery To:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_DeliveryCompanyName" value={formData.vc_DeliveryCompanyName} onChange={handleFieldChange} />
                                        {errors.vc_DeliveryCompanyName && <div style={{ color: 'red' }}>{errors.vc_DeliveryCompanyName}</div>}
                                    </div>
                                </div>

                                {/* Table to list parts */}
                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px", "marginTop": "10px" }}>
                                    <table className="table table-striped table-bordered" ref={tableRef} style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                <th className="no-wrap">Product Code</th>
                                                <th className="no-wrap">Depot</th>
                                                <th className="no-wrap">Serial/Batch Number</th>
                                                <th className="no-wrap">Description</th>
                                                <th className="no-wrap">Ordered</th>
                                                <th className="no-wrap">Received</th>
                                                <th className="no-wrap">Delivered</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {parts.map((part, index) => {
                                                // Ensure vc_UnitOfSale is set to 0 if it's not already set
                                                if (!part.vc_UnitOfSale) {
                                                    part.vc_UnitOfSale = 0;
                                                }

                                                return (
                                                    <tr key={part.PK_PurchaseOrderItem_ID}>
                                                        <td className="no-wrap">{part.vc_StockCode}</td>
                                                        <td className="no-wrap">
                                                            {/* Depot selection, default "Base" */}
                                                            {part.PK_Stock_ID > 0 && CustomerID === 0 && jobID === 0 && (
                                                                <div className="depot-selection">
                                                                    <span
                                                                        className="selected-depot"
                                                                        onClick={() => openDepotModal(part.PK_Stock_ID, part.PK_PurchaseOrderItem_ID)}
                                                                        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                                                    >
                                                                        {selectedDepot[part.PK_PurchaseOrderItem_ID]?.vc_Name // Check if depot has been selected
                                                                            || (part.FK_Location_ID_Stock > 0
                                                                                ? `${part.vc_Name}` // Placeholder until stockLocationList is loaded
                                                                                : 'Base')}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td className="no-wrap">
                                                            {(part.snt_SerialTracking === 2 || part.snt_SerialTracking === "2") && (
                                                                <button type='button' className="btn btn-link" onClick={() => openModal('serial', part)}>
                                                                    {part.serialNumbers && part.serialNumbers.length > 0 ? 'Serial Numbers Defined' : 'Add Serial Number'}
                                                                </button>
                                                            )}
                                                            {part.bit_BatchManagement === 1 && (
                                                                <button type='button' className="btn btn-link" onClick={() => openModal('batch', part)}>
                                                                    {part.vc_BatchNumber || 'Add Batch Number'}
                                                                </button>
                                                            )}

                                                        </td>
                                                        <td className="no-wrap">{truncateText(part.vc_Description)}</td>
                                                        <td className="no-wrap">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={part.dec_OnOrder}
                                                                disabled={true}
                                                            />
                                                        </td>
                                                        <td className="no-wrap">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={part.dec_Delivered}
                                                                disabled={true}
                                                            />
                                                        </td>
                                                        <td className="no-wrap">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={part.vc_UnitOfSale}
                                                                onChange={(e) => handlePartChange(index, e.target.value, "vc_UnitOfSale")}  // Allow changes
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                    {errors.depot && <div style={{ color: 'red' }}>{errors.depot}</div>}
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px", "marginTop": "10px" }}>
                                    <div className="col-sm-12">
                                        <h6>Goods Received Note details</h6>
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px", "marginTop": "10px" }}>
                                    <label htmlFor="bnt_DeliveryNumber" className="col-sm-2 col-form-label">Supplier GRN No.:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="bnt_DeliveryNumber" value={formData.bnt_DeliveryNumber} onChange={handleFieldChange} />
                                        {errors.bnt_DeliveryNumber && <div style={{ color: 'red' }}>{errors.bnt_DeliveryNumber}</div>}
                                    </div>
                                    <label htmlFor="dt_DeliveryDate" className="col-sm-2 col-form-label">GRN Date:</label>
                                    <div className="col-sm-4">
                                        <input type="date" className="form-control" name="dt_DeliveryDate" value={formData.dt_DeliveryDate} onChange={handleFieldChange} />
                                        {errors.dt_DeliveryDate && <div style={{ color: 'red' }}>{errors.dt_DeliveryDate}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "10px", "marginTop": "30px" }}>
                                    <label htmlFor="Type" className="col-sm-4 col-form-label">Do you want to Complete this order?</label>
                                    <div className="col-sm-1">
                                        <div>
                                            <input className="form-check-input" type="radio" checked={formData.Complete === '0'} name="Complete" value="0" onChange={handleRadioChange} />
                                        </div>
                                        <div style={{ "marginLeft": "17px" }}>
                                            <label className="">No</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-1">
                                        <div>
                                            <input className="form-check-input" type="radio" checked={formData.Complete === '1'} name="Complete" value="1" onChange={handleRadioChange} />
                                        </div>
                                        <div style={{ "marginLeft": "17px" }}>
                                            <label className="">Yes</label>
                                        </div>
                                    </div>

                                </div>

                                {/* Modal for selecting depot */}
                                {showDepotModal && (
                                    <div className="modal fade show" style={{ display: 'block' }}>
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Select Depot</h5>
                                                    <button type="button" className="btn-close" onClick={() => setShowDepotModal(false)}></button>
                                                </div>
                                                <div className="modal-body">
                                                    <ul className="list-group">
                                                        {stockLocationList.map((depot) => (
                                                            <li
                                                                key={depot.PK_StockLocation_ID}
                                                                className="list-group-item"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => handleDepotSelect(depot)}
                                                            >
                                                                {depot.vc_Name}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                )}

                            </div>

                            <div className="modal-footer">
                                <button type="submit" className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>
                                    <i className="icofont-save" aria-hidden="true">
                                        Save
                                    </i>
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                            </div>
                        </div>
                    </form>
                </Draggable>
            </div>
            {modalType && <BatchSerialModal show={true} onClose={() => setModalType(null)} onSave={handleSave} type={modalType} part={selectedPart} />}
        </div>
    );
}

export default PurchaseOrderDeliveryModal;
